import { useCallback } from "react";
import { useAsu, toFakeUtc } from "@framework/provider-asu";
import { formatDateHumanReadable } from "../utils";

export const useFormatDateHumanReadable = () => {
  const { dbTz } = useAsu();
  return useCallback(
    (date: Date | string, options?: { withSeconds?: boolean }) => {
      const shifted = toFakeUtc(date, dbTz);
      return formatDateHumanReadable(shifted, options);
    },
    [dbTz],
  );
};
